import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseListComponent } from '../../../classes/base-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'vss-ui-notification-popup',
    templateUrl: './notification-popup.component.html',
    styleUrls: ['./notification-popup.component.scss']
})
export class NotificationPopupComponent extends BaseListComponent implements OnInit {
    @Input() messageNotification: string = '';
    @Input() title: string = ''
    @Input() isOpenModal: boolean = false;
    @Input() isWarning: boolean = false;
    @Input() isErrors: boolean = false;
    @Input() isSuccess: boolean = false;
    @Input() isDelete: boolean = false;
    @Input() selectedGroupName: any[] = [];
    @Input() isCheckPunish: boolean = false;
    @Input() isCheckErrTable: boolean = false;
    @Input() isCheckViolation: boolean = false;
    @Input() isCheckFunctionMangement: boolean = false;
    @Input() checkedNodes: any = { ids: [], keys: [] };
    @Input() checkedModules: any[] = [];
    @Input() menus: any[] = [];
    @Input() isShowOk: boolean = true
    @Input() isShowCancel: boolean = true
    @Input() labelOk: string = ''
    @Input() labelCancel: string = ''

    @Input() username: string = ''
    @Input() mail: string = ''
    @Input() uploadFile: any


    @Output() onCloseModal = new EventEmitter();
    @Output() itemDeleteOk = new EventEmitter();

    constructor(
        public translate: TranslateService
    ) {
        super()
    }

    fileSize: any = 0;
    ngOnInit() {
        if (this.uploadFile) this.fileSize = (this.uploadFile.size / (1024 * 1024)).toFixed(3)
    }

    deleteCancel() {
        this.onCloseModal.emit();
    }

    deleteOk() {
        this.itemDeleteOk.emit(true);
    }

}
